<template>
    <div id="layoutDefault_footer">
        <footer class="footer pt-10 pb-5 mt-auto bg-dark footer-dark">
            <div class="container">
                <div class="row">
                    <div class="col-lg-9">
                        <div class="row">
                            <div class="col-lg-5 col-md-6 mb-5 mb-lg-0">
                                <div
                                    class="text-uppercase-expanded text-xs mb-4"
                                >
                                    REDES SOCIAIS
                                </div>
                                <ul class="list-unstyled mb-0">
                                    <li class="mb-2" v-if="app.facebook">
                                        <a
                                            class="icon-list-social-link"
                                            :href="app.facebook"
                                            target="_blank"
                                        >
                                            <i
                                                class="fab fa-facebook fa-fw"
                                            ></i>
                                            Facebook
                                        </a>
                                    </li>
                                    <li class="mb-2" v-if="app.instagram">
                                        <a
                                            class="icon-list-social-link"
                                            :href="app.instagram"
                                            target="_blank"
                                        >
                                            <i
                                                class="fab fa-instagram fa-fw"
                                            ></i>
                                            Instagram
                                        </a>
                                    </li>
                                    <li class="mb-2" v-if="app.twitter">
                                        <a
                                            class="icon-list-social-link"
                                            :href="app.twitter"
                                            target="_blank"
                                        >
                                            <i class="fab fa-twitter fa-fw"></i>
                                            Twitter
                                        </a>
                                    </li>
                                    <li class="mb-2" v-if="app.youtube">
                                        <a
                                            class="icon-list-social-link"
                                            :href="app.youtube"
                                            target="_blank"
                                        >
                                            <i class="fab fa-youtube fa-fw"></i>
                                            YouTube
                                        </a>
                                    </li>
                                    <li class="mb-2" v-if="app.linkedin">
                                        <a
                                            class="icon-list-social-link"
                                            :href="app.linkedin"
                                            target="_blank"
                                        >
                                            <i
                                                class="fab fa-linkedin fa-fw"
                                            ></i>
                                            LinkedIn
                                        </a>
                                    </li>
                                </ul>
                            </div>

                            <div class="col-lg-6 col-md-6">
                                <ul class="list-unstyled mb-0">
                                    <li class="mb-2" v-if="loja.razao_social">
                                        <b>
                                            {{ loja.razao_social }}
                                        </b>
                                    </li>
                                    <li class="mb-2">
                                        <b>CNPJ:</b>
                                        {{
                                            loja.cnpj
                                                ? loja.cnpj
                                                : '00.000.000/0000-00'
                                        }}
                                    </li>
                                    <li class="mb-2">
                                        <b>Endereço:</b>
                                        {{ loja.endereco ? loja.endereco : '' }}
                                    </li>
                                    <li>
                                        {{ app.email }}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="col-lg-3">
                        <div class="footer-brand">
                            {{ app.nome }}
                        </div>
                        <div class="mb-3" style="text-align: justify;">
                            Tudo em um só lugar! Toda a gestão contábil,
                            tributária e financeira da sua empresa feita de modo
                            fácil e rápido pela nossa plataforma.
                        </div>
                    </div>
                </div>
                <hr class="my-5" />
                <div class="row align-items-center">
                    <div class="col-md-6 small">
                        <!-- Copyright &copy; Seu Website 2020 -->
                    </div>
                    <div class="col-md-6 text-md-right small">
                        <a href="javascript:void(0);">
                            <!-- Política de Privacidade -->
                        </a>
                        <a href="javascript:void(0);">
                            © Todos direitos reservados
                        </a>
                    </div>
                </div>
            </div>

            <div class="botao_whatsapp_app left" v-if="atendimentos.whatsapp">
                <a
                    :href="
                        ($isMobile()
                            ? `whatsapp://send?phone=55${somenteNumeros(atendimentos.whatsapp)}&text=`
                            : `https://web.whatsapp.com/send?phone=55${somenteNumeros(atendimentos.whatsapp)}&text=`) 
                            + mensagemWhatsApp
                    "
                    target="_blank"
                    class="botao_whatsapp"
                >
                    <span class="botao_whatsapp_primary">
                        <span class="close">x</span>
                        &nbsp;
                    </span>
                </a>
            </div>
        </footer>
    </div>
</template>
<script>
import { somenteNumeros } from '@/shared/common/functions/numero'
export default {
    props: ['app', 'atendimentos', 'loja', 'mensagemWhatsApp'],
    data() {
        return {
            somenteNumeros
        }
    }
}
</script>
